import React from 'react';
import classNames from 'classnames';
import { Trans } from 'react-i18next';

import './ReleaseOrderNote.styles.scss';

type ReleaseOrderNoteProps = {
  className?: string;
  name: string;
  // Wraps "automated file release process"; each drawer links to Automation its own way.
  automationLink: React.ReactElement;
};

const ReleaseOrderNote: React.FC<ReleaseOrderNoteProps> = (props) => {
  const { className, name, automationLink } = props;

  return (
    <p className={classNames('release-order-note', className)}>
      <Trans
        i18nKey="leadInAutomatedFileRelease"
        values={{ name }}
        components={{ automation: automationLink }}
      />
    </p>
  );
};

export default ReleaseOrderNote;
